module.exports = __webpack_public_path__ + "img/license-CC BY-NC-SA.9b2b5466.png";